export default __webpack_public_path__ + "static/media/logo_bean.3dd9224e.png";